import React from 'react';
import { FormattedMessage } from 'react-intl';

export enum PackageActionName {
    PACKAGE_CHANGE_STATE = 'package_change_state',
    PACKAGE_ACKNOWLEDGE_PROCESSING = 'package_acknowledge_processing',
    PACKAGE_ACKNOWLEDGE_PROCESSED = 'package_acknowledge_processed',
    PACKAGE_ACKNOWLEDGE_CANCELLED = 'package_acknowledge_cancelled',
    PACKAGE_ACKNOWLEDGE_FAILED = 'package_acknowledge_failed',
    PACKAGE_ACKNOWLEDGE_SLOT_OPENED = 'package_acknowledge_slot_opened',
    PACKAGE_ACKNOWLEDGE_SLOT_NOT_OPENED = 'package_acknowledge_slot_not_opened',
    PACKAGE_ACKNOWLEDGE_SLOT_CLOSED = 'package_acknowledge_slot_closed',
    PACKAGE_ACKNOWLEDGE_SLOT_NOT_CLOSED = 'package_acknowledge_slot_not_closed',
    PACKAGE_ADD_TO_STOCK = 'package_add_to_stock',
    PACKAGE_REMOVE_FROM_STOCK = 'package_remove_from_stock',
    PACKAGE_RETURN_EQUIPMENT = 'package_return_equipment',
    PACKAGE_WITHDRAW_EQUIPMENT = 'package_withdraw_equipment',
    PACKAGE_UPDATE_BUDGET_USE = 'package_update_budget_use',
    PACKAGE_CREATE_PIN_CODE = 'package_create_pin_code',
    PACKAGE_SET_PIN_CODE = 'package_set_pin_code',
    PACKAGE_RETIRE_PIN_CODE = 'package_retire_pin_code',
    PACKAGE_OPEN_SLOT = 'package_open_slot',
    PACKAGE_CANCEL_SLOT = 'package_cancel_slot',
    PACKAGE_NOTIFY_SENDER = 'package_notify_sender',
    PACKAGE_NOTIFY_RECEIVER = 'package_notify_receiver',
    PACKAGE_NOTIFY_BACKUP_RECEIVER = 'package_notify_backup_receiver',
    PACKAGE_GRANT_ACCESS = 'package_grant_access',
    PACKAGE_DENY_ACCESS = 'package_deny_access',
    PACKAGE_TRANSACTION_DROPPED_OFF = 'package_transaction_dropped_off',
    PACKAGE_TRANSACTION_PICKED_UP = 'package_transaction_picked_up',
    PACKAGE_INFORM_IOT_PROCESSING = 'package_inform_iot_processing',
    PACKAGE_INFORM_IOT_PROCESSED = 'package_inform_iot_processed',
    PACKAGE_INFORM_IOT_CANCELLED = 'package_inform_iot_cancelled',
    PACKAGE_INFORM_IOT_FAILED = 'package_inform_iot_failed',
    PACKAGE_INFORM_IOT_SLOT_OPENED = 'package_inform_iot_slot_opened',
    PACKAGE_INFORM_IOT_SLOT_NOT_OPENED = 'package_inform_iot_slot_not_opened',
    PACKAGE_INFORM_IOT_SLOT_CLOSED = 'package_inform_iot_slot_closed',
    PACKAGE_INFORM_IOT_SLOT_MOVED = 'package_inform_iot_slot_moved',
    PACKAGE_INFORM_IOT_SLOT_NOT_CLOSED = 'package_inform_iot_slot_not_closed',
    PACKAGE_INFORM_IOT_IDENTIFIED = 'package_inform_iot_identified',
    PACKAGE_INFORM_IOT_STATE_CHANGED = 'package_inform_iot_state_changed',
    PACKAGE_SKIP_BEFORE = 'package_skip_before',
    PACKAGE_SKIP_AFTER = 'package_skip_after',
    PACKAGE_UPDATE_COLLI_CURRENT_LOCATION = 'package_update_colli_current_location',
    PACKAGE_LOG_SLOT_NOT_OPENED = 'package_log_slot_not_opened',
    PACKAGE_LOG_SLOT_NOT_CLOSED = 'package_log_slot_not_closed',
    SHOW_WIZARD = 'show_wizard'
}

export class PackageAction {
    static readonly PACKAGE_CHANGE_STATE = new PackageAction(
        PackageActionName.PACKAGE_CHANGE_STATE,
        (
            <FormattedMessage
                id='packageAction.change_state'
                description='package action change state'
                defaultMessage='Change state'
            />
        )
    );

    static readonly PACKAGE_ACKNOWLEDGE_PROCESSING = new PackageAction(
        PackageActionName.PACKAGE_ACKNOWLEDGE_PROCESSING,
        (
            <FormattedMessage
                id='packageAction.acknowledge_processing'
                description='package action acknowledge processing'
                defaultMessage='Acknowledge processing'
            />
        )
    );

    static readonly PACKAGE_ACKNOWLEDGE_PROCESSED = new PackageAction(
        PackageActionName.PACKAGE_ACKNOWLEDGE_PROCESSED,
        (
            <FormattedMessage
                id='packageAction.acknowledge_processed'
                description='package action acknowledge processed'
                defaultMessage='Acknowledge processed'
            />
        )
    );

    static readonly PACKAGE_ACKNOWLEDGE_CANCELLED = new PackageAction(
        PackageActionName.PACKAGE_ACKNOWLEDGE_CANCELLED,
        (
            <FormattedMessage
                id='packageAction.acknowledge_cancelled'
                description='package action acknowledge cancelled'
                defaultMessage='Acknowledge cancelled'
            />
        )
    );

    static readonly PACKAGE_ACKNOWLEDGE_FAILED = new PackageAction(
        PackageActionName.PACKAGE_ACKNOWLEDGE_FAILED,
        (
            <FormattedMessage
                id='packageAction.acknowledge_failed'
                description='package action acknowledge failed'
                defaultMessage='Acknowledge failed'
            />
        )
    );

    static readonly PACKAGE_ACKNOWLEDGE_SLOT_OPENED = new PackageAction(
        PackageActionName.PACKAGE_ACKNOWLEDGE_SLOT_OPENED,
        (
            <FormattedMessage
                id='packageAction.acknowledge_slot_opened'
                description='package action acknowledge SLOT opened'
                defaultMessage='Acknowledge SLOT opened'
            />
        )
    );

    static readonly PACKAGE_ACKNOWLEDGE_SLOT_NOT_OPENED = new PackageAction(
        PackageActionName.PACKAGE_ACKNOWLEDGE_SLOT_NOT_OPENED,
        (
            <FormattedMessage
                id='packageAction.acknowledge_slot_not_opened'
                description='package action acknowledge SLOT not opened'
                defaultMessage='Acknowledge SLOT not opened'
            />
        )
    );

    static readonly PACKAGE_ACKNOWLEDGE_SLOT_CLOSED = new PackageAction(
        PackageActionName.PACKAGE_ACKNOWLEDGE_SLOT_CLOSED,
        (
            <FormattedMessage
                id='packageAction.acknowledge_slot_closed'
                description='package action acknowledge SLOT closed'
                defaultMessage='Acknowledge SLOT closed'
            />
        )
    );

    static readonly PACKAGE_ACKNOWLEDGE_SLOT_NOT_CLOSED = new PackageAction(
        PackageActionName.PACKAGE_ACKNOWLEDGE_SLOT_NOT_CLOSED,
        (
            <FormattedMessage
                id='packageAction.acknowledge_slot_not_closed'
                description='package action acknowledge SLOT not closed'
                defaultMessage='Acknowledge SLOT not closed'
            />
        )
    );

    static readonly PACKAGE_ADD_TO_STOCK = new PackageAction(
        PackageActionName.PACKAGE_ADD_TO_STOCK,
        (
            <FormattedMessage
                id='packageAction.add_to_stock'
                description='package action add to stock'
                defaultMessage='Add to stock'
            />
        )
    );

    static readonly PACKAGE_REMOVE_FROM_STOCK = new PackageAction(
        PackageActionName.PACKAGE_REMOVE_FROM_STOCK,
        (
            <FormattedMessage
                id='packageAction.remove_from_stock'
                description='package action remove from stock'
                defaultMessage='Remove from stock'
            />
        )
    );

    static readonly PACKAGE_RETURN_EQUIPMENT = new PackageAction(
        PackageActionName.PACKAGE_RETURN_EQUIPMENT,
        (
            <FormattedMessage
                id='packageAction.return_equipment'
                description='package action return equipment'
                defaultMessage='Return equipment'
            />
        )
    );

    static readonly PACKAGE_WITHDRAW_EQUIPMENT = new PackageAction(
        PackageActionName.PACKAGE_WITHDRAW_EQUIPMENT,
        (
            <FormattedMessage
                id='packageAction.withdraw_equipment'
                description='package action withdraw equipment'
                defaultMessage='Withdraw equipment'
            />
        )
    );

    static readonly PACKAGE_UPDATE_BUDGET_USE = new PackageAction(
        PackageActionName.PACKAGE_UPDATE_BUDGET_USE,
        (
            <FormattedMessage
                id='packageAction.update_budget_use'
                description='package action update budget use'
                defaultMessage='Update budget use'
            />
        )
    );

    static readonly PACKAGE_CREATE_PIN_CODE = new PackageAction(
        PackageActionName.PACKAGE_CREATE_PIN_CODE,
        (
            <FormattedMessage
                id='packageAction.create_pin_code'
                description='package action create PIN-code'
                defaultMessage='Create PIN-code'
            />
        )
    );

    static readonly PACKAGE_SET_PIN_CODE = new PackageAction(
        PackageActionName.PACKAGE_SET_PIN_CODE,
        (
            <FormattedMessage
                id='packageAction.set_pin_code'
                description='package action set PIN-code'
                defaultMessage='Set PIN-code'
            />
        )
    );

    static readonly PACKAGE_RETIRE_PIN_CODE = new PackageAction(
        PackageActionName.PACKAGE_RETIRE_PIN_CODE,
        (
            <FormattedMessage
                id='packageAction.retire_pin_code'
                description='package action retire PIN-code'
                defaultMessage='Retire PIN-code'
            />
        )
    );

    static readonly PACKAGE_OPEN_SLOT = new PackageAction(
        PackageActionName.PACKAGE_OPEN_SLOT,
        (
            <FormattedMessage
                id='packageAction.open_slot'
                description='package action open slot'
                defaultMessage='Open SLOT'
            />
        )
    );

    static readonly PACKAGE_CANCEL_SLOT = new PackageAction(
        PackageActionName.PACKAGE_CANCEL_SLOT,
        (
            <FormattedMessage
                id='packageAction.cancel_slot'
                description='package action cancel slot'
                defaultMessage='Cancel SLOT'
            />
        )
    );

    static readonly PACKAGE_NOTIFY_SENDER = new PackageAction(
        PackageActionName.PACKAGE_NOTIFY_SENDER,
        (
            <FormattedMessage
                id='packageAction.notify_sender'
                description='package action notify sender'
                defaultMessage='Notify sender'
            />
        )
    );

    static readonly PACKAGE_NOTIFY_RECEIVER = new PackageAction(
        PackageActionName.PACKAGE_NOTIFY_RECEIVER,
        (
            <FormattedMessage
                id='packageAction.notify_receiver'
                description='package action notify receiver'
                defaultMessage='Notify receiver'
            />
        )
    );

    static readonly PACKAGE_NOTIFY_BACKUP_RECEIVER = new PackageAction(
        PackageActionName.PACKAGE_NOTIFY_BACKUP_RECEIVER,
        (
            <FormattedMessage
                id='packageAction.notify_backup_receiver'
                description='package action notify backup receiver'
                defaultMessage='Notify backup receiver'
            />
        )
    );

    static readonly PACKAGE_GRANT_ACCESS = new PackageAction(
        PackageActionName.PACKAGE_GRANT_ACCESS,
        (
            <FormattedMessage
                id='packageAction.grant_access'
                description='package action grant access'
                defaultMessage='Grant access'
            />
        )
    );

    static readonly PACKAGE_DENY_ACCESS = new PackageAction(
        PackageActionName.PACKAGE_DENY_ACCESS,
        (
            <FormattedMessage
                id='packageAction.deny_access'
                description='package action deny access'
                defaultMessage='Deny access'
            />
        )
    );

    static readonly PACKAGE_TRANSACTION_DROPPED_OFF = new PackageAction(
        PackageActionName.PACKAGE_TRANSACTION_DROPPED_OFF,
        (
            <FormattedMessage
                id='packageAction.transaction_dropped_off'
                description='package action transaction dropped off'
                defaultMessage='Transaction dropped off'
            />
        )
    );

    static readonly PACKAGE_TRANSACTION_PICKED_UP = new PackageAction(
        PackageActionName.PACKAGE_TRANSACTION_PICKED_UP,
        (
            <FormattedMessage
                id='packageAction.transaction_picked_up'
                description='package action transaction picked up'
                defaultMessage='Transaction picked up'
            />
        )
    );

    static readonly PACKAGE_INFORM_IOT_PROCESSING = new PackageAction(
        PackageActionName.PACKAGE_INFORM_IOT_PROCESSING,
        (
            <FormattedMessage
                id='packageAction.inform_iot_processing'
                description='package action inform iot processing'
                defaultMessage='Inform IoT processing'
            />
        )
    );

    static readonly PACKAGE_INFORM_IOT_PROCESSED = new PackageAction(
        PackageActionName.PACKAGE_INFORM_IOT_PROCESSED,
        (
            <FormattedMessage
                id='packageAction.inform_iot_processed'
                description='package action inform iot processed'
                defaultMessage='Inform IoT processed'
            />
        )
    );

    static readonly PACKAGE_INFORM_IOT_CANCELLED = new PackageAction(
        PackageActionName.PACKAGE_INFORM_IOT_CANCELLED,
        (
            <FormattedMessage
                id='packageAction.inform_iot_cancelled'
                description='package action inform iot cancelled'
                defaultMessage='Inform IoT cancelled'
            />
        )
    );

    static readonly PACKAGE_INFORM_IOT_FAILED = new PackageAction(
        PackageActionName.PACKAGE_INFORM_IOT_FAILED,
        (
            <FormattedMessage
                id='packageAction.inform_iot_failed'
                description='package action inform iot failed'
                defaultMessage='Inform IoT failed'
            />
        )
    );

    static readonly PACKAGE_INFORM_IOT_SLOT_OPENED = new PackageAction(
        PackageActionName.PACKAGE_INFORM_IOT_SLOT_OPENED,
        (
            <FormattedMessage
                id='packageAction.inform_iot_slot_opened'
                description='package action inform iot SLOT opened'
                defaultMessage='Inform IoT SLOT opened'
            />
        )
    );

    static readonly PACKAGE_INFORM_IOT_SLOT_NOT_OPENED = new PackageAction(
        PackageActionName.PACKAGE_INFORM_IOT_SLOT_NOT_OPENED,
        (
            <FormattedMessage
                id='packageAction.inform_iot_slot_not_opened'
                description='package action inform iot SLOT not opened'
                defaultMessage='Inform IoT SLOT not opened'
            />
        )
    );

    static readonly PACKAGE_INFORM_IOT_SLOT_CLOSED = new PackageAction(
        PackageActionName.PACKAGE_INFORM_IOT_SLOT_CLOSED,
        (
            <FormattedMessage
                id='packageAction.inform_iot_slot_closed'
                description='package action inform iot SLOT closed'
                defaultMessage='Inform IoT SLOT closed'
            />
        )
    );

    static readonly PACKAGE_INFORM_IOT_SLOT_MOVED = new PackageAction(
        PackageActionName.PACKAGE_INFORM_IOT_SLOT_MOVED,
        (
            <FormattedMessage
                id='packageAction.inform_iot_slot_moved'
                description='package action inform iot SLOT moved'
                defaultMessage='Inform IoT SLOT moved'
            />
        )
    );

    static readonly PACKAGE_INFORM_IOT_SLOT_NOT_CLOSED = new PackageAction(
        PackageActionName.PACKAGE_INFORM_IOT_SLOT_NOT_CLOSED,
        (
            <FormattedMessage
                id='packageAction.inform_iot_slot_not_closed'
                description='package action inform iot SLOT not closed'
                defaultMessage='Inform IoT SLOT not closed'
            />
        )
    );

    static readonly PACKAGE_INFORM_IOT_IDENTIFIED = new PackageAction(
        PackageActionName.PACKAGE_INFORM_IOT_IDENTIFIED,
        (
            <FormattedMessage
                id='packageAction.inform_iot_identified'
                description='package action inform iot identified'
                defaultMessage='Inform IoT identified'
            />
        )
    );

    static readonly PACKAGE_INFORM_IOT_STATE_CHANGED = new PackageAction(
        PackageActionName.PACKAGE_INFORM_IOT_STATE_CHANGED,
        (
            <FormattedMessage
                id='packageAction.inform_iot_state_changed'
                description='package action inform iot state changed'
                defaultMessage='Inform IoT state changed'
            />
        )
    );

    static readonly PACKAGE_SKIP_BEFORE = new PackageAction(
        PackageActionName.PACKAGE_SKIP_BEFORE,
        (
            <FormattedMessage
                id='packageAction.skip_before'
                description='package action skip before'
                defaultMessage='Skip before'
            />
        )
    );

    static readonly PACKAGE_SKIP_AFTER = new PackageAction(
        PackageActionName.PACKAGE_SKIP_AFTER,
        (
            <FormattedMessage
                id='packageAction.skip_after'
                description='package action skip after'
                defaultMessage='Skip after'
            />
        )
    );

    static readonly SHOW_WIZARD = new PackageAction(
        PackageActionName.SHOW_WIZARD,
        (
            <FormattedMessage
                id='packageAction.show_wizard'
                description='package action show wizard'
                defaultMessage='Show wizard'
            />
        )
    );
    static readonly PACKAGE_UPDATE_COLLI_CURRENT_LOCATION = new PackageAction(
        PackageActionName.PACKAGE_UPDATE_COLLI_CURRENT_LOCATION,
        (
            <FormattedMessage
                id='packageAction.update_colli_current_location'
                description='package action update colli current location'
                defaultMessage='Update colli current location'
            />
        )
    );

    static readonly PACKAGE_LOG_SLOT_NOT_OPENED = new PackageAction(
        PackageActionName.PACKAGE_LOG_SLOT_NOT_OPENED,
        (
            <FormattedMessage
                id='packageAction.log_slot_not_opened'
                description='package action log SLOT not opened'
                defaultMessage='Log SLOT not opened'
            />
        )
    );

    static readonly PACKAGE_LOG_SLOT_NOT_CLOSED = new PackageAction(
        PackageActionName.PACKAGE_LOG_SLOT_NOT_CLOSED,
        (
            <FormattedMessage
                id='packageAction.log_slot_not_closed'
                description='package action log SLOT not closed'
                defaultMessage='Log SLOT not closed'
            />
        )
    );

    static readonly ALL = [
        PackageAction.PACKAGE_CHANGE_STATE,
        PackageAction.PACKAGE_ACKNOWLEDGE_PROCESSING,
        PackageAction.PACKAGE_ACKNOWLEDGE_PROCESSED,
        PackageAction.PACKAGE_ACKNOWLEDGE_CANCELLED,
        PackageAction.PACKAGE_ACKNOWLEDGE_FAILED,
        PackageAction.PACKAGE_ACKNOWLEDGE_SLOT_OPENED,
        PackageAction.PACKAGE_ACKNOWLEDGE_SLOT_NOT_OPENED,
        PackageAction.PACKAGE_ACKNOWLEDGE_SLOT_CLOSED,
        PackageAction.PACKAGE_ACKNOWLEDGE_SLOT_NOT_CLOSED,
        PackageAction.PACKAGE_ADD_TO_STOCK,
        PackageAction.PACKAGE_REMOVE_FROM_STOCK,
        PackageAction.PACKAGE_RETURN_EQUIPMENT,
        PackageAction.PACKAGE_WITHDRAW_EQUIPMENT,
        PackageAction.PACKAGE_UPDATE_BUDGET_USE,
        PackageAction.PACKAGE_CREATE_PIN_CODE,
        PackageAction.PACKAGE_SET_PIN_CODE,
        PackageAction.PACKAGE_RETIRE_PIN_CODE,
        PackageAction.PACKAGE_OPEN_SLOT,
        PackageAction.PACKAGE_CANCEL_SLOT,
        PackageAction.PACKAGE_NOTIFY_SENDER,
        PackageAction.PACKAGE_NOTIFY_RECEIVER,
        PackageAction.PACKAGE_NOTIFY_BACKUP_RECEIVER,
        PackageAction.PACKAGE_GRANT_ACCESS,
        PackageAction.PACKAGE_DENY_ACCESS,
        PackageAction.PACKAGE_TRANSACTION_DROPPED_OFF,
        PackageAction.PACKAGE_TRANSACTION_PICKED_UP,
        PackageAction.PACKAGE_INFORM_IOT_PROCESSING,
        PackageAction.PACKAGE_INFORM_IOT_PROCESSED,
        PackageAction.PACKAGE_INFORM_IOT_CANCELLED,
        PackageAction.PACKAGE_INFORM_IOT_FAILED,
        PackageAction.PACKAGE_INFORM_IOT_SLOT_OPENED,
        PackageAction.PACKAGE_INFORM_IOT_SLOT_NOT_OPENED,
        PackageAction.PACKAGE_INFORM_IOT_SLOT_CLOSED,
        PackageAction.PACKAGE_INFORM_IOT_SLOT_NOT_CLOSED,
        PackageAction.PACKAGE_INFORM_IOT_IDENTIFIED,
        PackageAction.PACKAGE_INFORM_IOT_STATE_CHANGED,
        PackageAction.PACKAGE_SKIP_BEFORE,
        PackageAction.PACKAGE_SKIP_AFTER,
        PackageAction.SHOW_WIZARD,
        PackageAction.PACKAGE_UPDATE_COLLI_CURRENT_LOCATION,
        PackageAction.PACKAGE_LOG_SLOT_NOT_OPENED,
        PackageAction.PACKAGE_LOG_SLOT_NOT_CLOSED
    ];
    private constructor(
        public readonly value: PackageActionName,
        public readonly displayName: React.ReactNode
    ) {}

    static getByValue(value: PackageActionName): PackageAction | undefined {
        return PackageAction.ALL.find((action) => action.value === value);
    }
}
